import {apiMe} from '@http/common'

const state = {
    userinfo: {},
    baseInfo:{}
}
const mutations = {
    setuserinfo(state, userinfo) {
        state.userinfo = userinfo
    },
    setBaseinfo(state, baseInfo) {
        state.baseInfo = baseInfo
    },
}
const actions = {
    serUserInfo({commit}) {
        return new Promise((resolve, reject) => {
            apiMe()
                .then(res => {
                    if (res) {
                        commit('setuserinfo', res.data)
                        commit('setBaseinfo', res.data)
                    }
                })
                .catch(err => reject(err));
        });
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
